import React, { useState } from "react";
import Switch from "react-bootstrap-switch";
import {connect, useSelector} from "react-redux";
import { useForm } from "react-hook-form";


// components
import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";

// labels
import {FL_DATE, FL_STATUS} from "../../../components/i18n/formLabels";

// actions

import { CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import {LB_EVENT} from "../../../components/i18n/i18n";
import SelectGeneric from "../../../components/select/selectGeneric";
import {eventProvider} from "../../../providers/eventx/eventProvider";
import {getStateByPath} from "../../../redux/selectors";
import {setFilter} from "../../../redux/actions/generics/IndexedActions";
import {activityProvider} from "../../../providers/activityProvider";
import {placeProvider} from "../../../providers/placeProvider";


const ItineraryFilters = props => {
    // const { filter } = props.listProps
    // const { app } = props.mainProps
    //
    // const fbDataBaseId = app?.fbDataBase?.id
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { filter, app, udn } = componentState?.data;


    const [categoryId, setCategoryId] = useState(  filter?.item?.category?.id || null);
    const [activityId, setActivityId] = useState(  filter?.item?.activity?.id || null);
    const [placeId, setPlaceId] = useState(  filter?.item?.place?.id || null);
    const [event, setEvent] = useState(filter?.item?.event?.id || null);
    const [status, setStatus] = useState( filter?.item?.status ?? null);

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const statusChange = () => {
        setStatus(!status);
    };

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))

        setStatus(null);
        setEvent(null);
        setCategoryId(null);
        setActivityId(null);
        setPlaceId(null);

        reset({
            date: null,
        });

        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.item.date;
        }

        props.setFilter(path, tmpFilter);
    }

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            date: filter?.item?.date,
        }
    });

    const onSubmit = (data, _) => {
        if(!app?.fbDataBase?.id)
            return

        const dataFilter = {
            onlyRegistered : true,
            fbDataBase : {  id : app?.fbDataBase?.id },
            item : {
                ...data,
                udn : { id: udn.id }
            }
        }

        if (status !== undefined && status !== null)
            dataFilter.item.status = status;

        if(event != null)
            dataFilter.item.event = { id : event };

        if (categoryId != null)
            dataFilter.item.category = { id : categoryId };

        if (activityId != null)
            dataFilter.item.activity = { id : activityId };

        if (placeId != null)
            dataFilter.item.place = { id : placeId };


        props.setFilter(path, dataFilter);
    };

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody className="">
            <Row>
                <Col md={'4'}>
                    <FormGroup>
                        <Label>{LB_EVENT}</Label>
                        <SelectGeneric
                            provider={eventProvider}
                            initialValue={event}
                            setExternalValue={setEvent}
                            customFilter={{ item: { udn: {id: udn?.id }, status: true }} }
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label >{ 'Actividad / Presentación' }</Label>
                        <SelectGeneric
                            initialValue={ activityId }
                            setExternalValue={ value =>  setActivityId(value) }
                            provider = { activityProvider }
                            customFilter={{
                                onlyRegistered: true,
                                fbDataBase :  { id : app?.fbDataBase?.id },
                                item: {
                                    udn: {id: udn?.id },
                                    status : null,
                                    isExtraordinary: false
                                }
                            }}
                            resetValue={ false }
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>{ 'Foro / Lugar' }</Label>
                        <SelectGeneric
                            initialValue={ placeId }
                            setExternalValue={ value =>  setPlaceId(value) }
                            provider = { placeProvider }
                            customFilter={{
                                onlyRegistered: true,
                                fbDataBase :  { id : app?.fbDataBase?.id },
                                item: { udn: {id: udn?.id } }
                            }}
                            resetValue={ false }
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>{ FL_DATE }</Label>
                        <Input
                            type="date"
                            name="date"
                            placeholder={ FL_DATE }
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>{ FL_STATUS }</Label>
                        <br />
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            innerRef={register}
                            onChange={statusChange}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div className="float-right">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(ItineraryFilters)